var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSilverWare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1.73706V18.4037H15.8333V12.5704H12.5V6.73706C12.5 5.41098 13.0268 4.13921 13.9645 3.20153C14.9021 2.26384 16.1739 1.73706 17.5 1.73706ZM15.8333 3.84539C15.1417 4.23706 14.1667 5.21206 14.1667 6.73706V10.9037H15.8333V3.84539ZM7.5 11.6537V18.4037H5.83333V11.6537C4.89234 11.4613 4.04666 10.9499 3.43929 10.2058C2.83191 9.46181 2.50012 8.53086 2.5 7.57039V2.57039H4.16667V8.40373H5.83333V2.57039H7.5V8.40373H9.16667V2.57039H10.8333V7.57039C10.8332 8.53086 10.5014 9.46181 9.89405 10.2058C9.28667 10.9499 8.44099 11.4613 7.5 11.6537Z",
    fill: "#0A0A28"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverWare);
export default __webpack_public_path__ + "static/media/silver-ware.92cfd5ecee53d922c9300f98affabe92.svg";
export { ForwardRef as ReactComponent };